const properties = [
  {
    code: "SA0005",
    type: "Sala comercial",
    city: "Esteio/RS",
    neighborhood: "Centro",
    condominium: "Reis Executive Center",
    area: 41,
    bedrooms: 0,
    bathrooms: 1,
    parkingSpaces: 1,
    price: 595000,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0092",
    type: "Apartamento",
    city: "Sapucaia do Sul/RS",
    neighborhood: "Pasqualini",
    condominium: "Residencial Nicolau Kuhn",
    area: 39,
    bedrooms: 2,
    bathrooms: 1,
    parkingSpaces: 1,
    price: 125000,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0097",
    type: "Cobertura duplex",
    city: "São Leopoldo/RS",
    neighborhood: "Morro do Espelho",
    condominium: "Condomínio Dom Augusto",
    area: 541,
    bedrooms: 4,
    bathrooms: 6,
    parkingSpaces: 4,
    price: 2400000,
    badge: "Oportunidade",
    image:
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0101",
    type: "Apartamento",
    city: "Esteio/RS",
    neighborhood: "Centro",
    condominium: "Edifício Jardim de Maio",
    area: 77,
    bedrooms: 2,
    bathrooms: 1,
    parkingSpaces: 1,
    price: 399900,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "CA0048",
    type: "Casa",
    city: "Sapucaia do Sul/RS",
    neighborhood: "Vargas",
    condominium: "Residencial das Araucárias",
    area: 126,
    bedrooms: 3,
    bathrooms: 2,
    parkingSpaces: 2,
    price: 520000,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0114",
    type: "Apartamento",
    city: "Esteio/RS",
    neighborhood: "Tamandaré",
    condominium: "Residencial Parque Verde",
    area: 68,
    bedrooms: 2,
    bathrooms: 2,
    parkingSpaces: 1,
    price: 345000,
    badge: "Novo",
    image:
      "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "CA0053",
    type: "Casa",
    city: "Esteio/RS",
    neighborhood: "São Sebastião",
    condominium: "Residencial das Flores",
    area: 148,
    bedrooms: 3,
    bathrooms: 2,
    parkingSpaces: 2,
    price: 680000,
    badge: "Oportunidade",
    image:
      "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0120",
    type: "Apartamento",
    city: "Sapucaia do Sul/RS",
    neighborhood: "Centro",
    condominium: "Residencial Bella Vista",
    area: 54,
    bedrooms: 2,
    bathrooms: 1,
    parkingSpaces: 1,
    price: 289000,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "CA0061",
    type: "Sobrado",
    city: "São Leopoldo/RS",
    neighborhood: "Cristo Rei",
    condominium: "Residencial Alameda",
    area: 172,
    bedrooms: 3,
    bathrooms: 3,
    parkingSpaces: 2,
    price: 749000,
    badge: "Novo",
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=900&q=85",
  },
  {
    code: "AP0132",
    type: "Apartamento",
    city: "Esteio/RS",
    neighborhood: "Parque Amador",
    condominium: "Residencial das Palmeiras",
    area: 82,
    bedrooms: 3,
    bathrooms: 2,
    parkingSpaces: 2,
    price: 465000,
    badge: "Financiável",
    image:
      "https://images.unsplash.com/photo-1600607687644-c7171b42498f?auto=format&fit=crop&w=900&q=85",
  },
];

export default properties;
